module.exports = __webpack_public_path__ + "img/05.0f257ee7.png";